import type { EventEmitter } from 'eventemitter3';
import EventEmitter3 from 'eventemitter3';

export type GameEvent =
  | 'currency-changed'
  | 'currency-fly'
  | 'outfit-equipped'
  | 'outfit-acquired'
  | 'minigame-completed'
  | 'navigate'
  | 'toast';

export const EventBus: EventEmitter = new EventEmitter3();
